import React, { useCallback } from 'react';
import { $location } from '@umu/umu-dom';

interface IProps {
    url?: string;
    codeOptions?: IQRCodeOptions;
}
export const QrGenerator = (props: IProps) => {
    const url = props.url || $location.href;
    const imgRef = useCallback(
        (node: HTMLDivElement) => {
            if (node && (window as any).QRCode) {
                node.innerHTML = '';
                // tslint:disable-next-line:no-unused-expression
                new QRCode(node, {
                    ...((props.codeOptions || {}) as IQRCodeOptions),
                    text: url,
                });
            }
        },
        [url],
    );
    return <div className="img" ref={imgRef}></div>;
};
